// extracted by mini-css-extract-plugin
export default {"footer":"zGY_vZKA text-muted","footerContainer":"KTEkIzGA","footerLinks":"ifDmsAuj","feedbackBtn":"rzNeeW7L"};